import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';
import {IPatientAssistantDialogue} from '../intervention/interfaces';

export const ASSISTANT_DIALOGUE_REQUESTED = 'ASSISTANT_DIALOGUE_REQUESTED';
export const assistantDialogueRequestedAction = (): IAction<null> => ({
  type: ASSISTANT_DIALOGUE_REQUESTED,
  payload: null
});

export const ASSISTANT_DIALOGUE_ASSIGNED = 'ASSISTANT_DIALOGUE_ASSIGNED';
export const assistantDialogueAssignedAction = (assistant: IPatientAssistantDialogue): IAction<IPatientAssistantDialogue> => ({
  type: ASSISTANT_DIALOGUE_ASSIGNED,
  payload: assistant
});

export const ASSISTANT_DIALOGUE_UNASSIGNED = 'ASSISTANT_DIALOGUE_UNASSIGNED';
export const assistantDialogueUnassignedAction = (): IAction<null> => ({
  type: ASSISTANT_DIALOGUE_UNASSIGNED,
  payload: null
});

export const ASSISTANT_DIALOGUE_UNAVAILABLE = 'ASSISTANT_DIALOGUE_UNAVAILABLE';
export const assistantDialogueUnavailableAction = (): IAction<null> => ({
  type: ASSISTANT_DIALOGUE_UNAVAILABLE,
  payload: null
});

export const ASSISTANT_DIALOGUE_CLEARED = 'ASSISTANT_DIALOGUE_CLEARED';
export const assistantDialogueClearedAction = (): IAction<null> => ({
  type: ASSISTANT_DIALOGUE_CLEARED,
  payload: null
});

const actions = {
  assistantDialogueRequestedAction,
  assistantDialogueAssignedAction,
  assistantDialogueUnassignedAction,
  assistantDialogueUnavailableAction,
  assistantDialogueClearedAction
};

export type AssistantActionsType = InferActionsTypes<typeof actions>
